import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const TokensResponseSchema = z.object({
    accessToken: z.string(),
    accessTokenTtl: z.number(),
    refreshToken: z.string(),
    refreshTokenTtl: z.number(),
});
export class TokensResponseDto extends createZodDto(TokensResponseSchema) {
}
